/**
 * @description 导出默认网路配置
 **/
export const network = {
    // 配后端数据的接收方式application/json;charset=UTF-8或者application/x-www-form-urlencoded;charset=UTF-8
    contentType: {
        form: 'application/x-www-form-urlencoded;charset=utf-8',
        json: 'application/json;charset=UTF-8',
        file: 'multipart/form-data;charset=utf-8',
        text: 'text/plain;charset=utf-8',
        html: 'text/html;charset=urf-8',
    },
    // 请求接口需要拼接的数据项, lib/request_*.js文件配置，此配置只说明有哪些，相关文档:http://10.12.68.61:8066/#/important
    paramsPath: ['instance', 'tenantId', 'TOKEN'], // 未来会有：'TOKEN'
    // 最长请求时间
    requestTimeout: 30000,
    // 操作正常的网关status，支持int类型
    successStatus: [200],
    // 操作正常的code，支持String、Array、int多种类型
    successCode: ['success', '200', 200],
    // 登录失效code
    invalidCode: 999,
    // 无权限code
    noPermissionCode: 401,
    // 代理配置,代理模式只有在npm run dev下有效, dev-mock下无效, 需要单独配置mock/mock-config.js或mock/proxy80.js或static-config.js
    proxyTable: {
        /* '/mwebapi': {
            target: 'http://172.22.145.6:20001',
            changeOrigin: true,
            pathRewrite: {
                '^/mwebapi': '/mwebapi',
            },
            secure: false,
        }, */
    },
};